module.exports = __webpack_public_path__ + "static/media/android-phone-and-tablt.c51ea88a.png";